const Seperator = () => (
  <div className="flex justify-center items-center">
    <div className="absolute w-3/4 h-0.5 rounded-lg shadow-inner shadow-black"></div>
  </div>
);

export default Seperator;
